export const purchaseOrdersListingRoutes = [
  {
    path: 'listing',
    name: 'purchase-orders-listing',
    component: () =>
      import(/* webpackChunkName: "purchase-orders-listing" */ './PurchaseOrdersListing.vue')
  }
];
